import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { emptyArr, emptyObj } from '@beef/utils';
import { getOrderTariffCommonData as selectDataFromOrderTariffPopup } from '@fttb/common/store';
import { createSelector } from '@reduxjs/toolkit';
import { DEFAULT_NOTIFICATION_VARIANT } from "./constants";
import { getNotificationsTexts as getCommonNotificationsTexts, getPopularTariffAlias } from "../checkAddress/selectors";
import { getModalTariffData } from "../../../components/OrderTariffFormPopup/OrderTariffFormOldPopup/store/selectors/orderTariffCommon";
import { selectFiasAddress } from "../addressVerification/moduleSelectors";
import { createMergedBlockSelector, getModulesData } from "../../selectors";
import { getFullAddress } from "../../checkAddress/selectors";
import { getTariffsBlock } from "../selectors";
export var getTariffsState = createSelector([getModulesData], function (state) {
  return state.tariffs || emptyObj;
});
export var selectCommonData = function selectCommonData(state) {
  return selectDataFromOrderTariffPopup(state).popupData || emptyObj;
};
export var getPresetUpFToggleFlag = function getPresetUpFToggleFlag(state) {
  return selectDataFromOrderTariffPopup(state).showPresetUpCheckAddress;
};
export var selectPresetUpCallbackFormFlag = function selectPresetUpCallbackFormFlag(state) {
  return selectDataFromOrderTariffPopup(state).showPresetUpCallbackForm;
};
export var getShowOnlyRouterInAlternativeUpTariff = function getShowOnlyRouterInAlternativeUpTariff(state) {
  return selectDataFromOrderTariffPopup(state).showOnlyRouterInAlternativeUpTariff;
};
export var getTariffTabs = function getTariffTabs(state) {
  return getTariffTabsSettings(state).tabs || emptyArr;
};
export var getTariffsGroup = function getTariffsGroup(state) {
  return getTariffsState(state).group || '';
};
export var getCurrentPopupState = function getCurrentPopupState(state) {
  return getTariffsState(state).currentPopupState;
};
export var selectIsLoadingTariffButton = function selectIsLoadingTariffButton(state) {
  return getTariffsState(state).tariffButtonLoading || emptyObj;
};
export var getTariffsDataFromHydrate = createMergedBlockSelector(getTariffsBlock);
export var getColoredTariffsData = function getColoredTariffsData(state) {
  return getTariffsState(state).coloredTariffsData;
};
export var getTariffsData = createSelector([getTariffsDataFromHydrate, getColoredTariffsData], function (tariffs, coloredTariffs) {
  if (coloredTariffs) {
    var link = tariffs.link,
      router = tariffs.router,
      valueGroups = tariffs.valueGroups;
    return _objectSpread(_objectSpread({}, coloredTariffs), {}, {
      link: link,
      router: router,
      valueGroups: valueGroups,
      buttonText: 'Подключить'
    });
  }
  return tariffs;
});
export var getTariffsLink = function getTariffsLink(state) {
  return getTariffsData(state).link || emptyObj;
};
export var getTariffsTitle = function getTariffsTitle(state) {
  return getTariffsData(state).title;
};
export var getTariffsHref = function getTariffsHref(state) {
  return getTariffsLink(state).href;
};
export var getTariffsTextLink = function getTariffsTextLink(state) {
  return getTariffsLink(state).textLink;
};
export var getTariffTabsSettings = function getTariffTabsSettings(state) {
  return getTariffsData(state).tabsSettings || emptyObj;
};
export var getTariffValueGroups = function getTariffValueGroups(state) {
  return getTariffsData(state).valueGroups || emptyArr;
};
export var getDataRouter = function getDataRouter(state) {
  return getTariffsData(state).router || emptyObj;
};
export var getGroupedTariffsList = function getGroupedTariffsList(state) {
  return getTariffsData(state).tariffs || emptyObj;
};
export var getTariffsList = createSelector([getGroupedTariffsList], function (tariffList) {
  return Object.values(tariffList).flat() || emptyArr;
});
export var getActiveTariffsIds = createSelector([getGroupedTariffsList, getTariffsGroup], function (tariffs, group) {
  var _tariffs$group;
  return ((_tariffs$group = tariffs[group]) === null || _tariffs$group === void 0 ? void 0 : _tariffs$group.map(function (tariff) {
    return tariff.alias;
  })) || emptyArr;
});

/** в случае, если по проверенном доме есть эксклюзивные тарифы - не показывать популярный */
export var showPopularTariff = createSelector([getPopularTariffAlias, getColoredTariffsData, getTariffsList], function (popularTariffAlias, isColoredTariffs, tariffsList) {
  var isPopularTariff = tariffsList.some(function (_ref) {
    var alias = _ref.alias;
    return alias === popularTariffAlias;
  });
  return isColoredTariffs || !isPopularTariff ? false : popularTariffAlias;
});

/** селекторы нотификации введенного адреса */
export var getColoredNotificationTexts = function getColoredNotificationTexts(state) {
  return getTariffsState(state).coloredNotificationData;
};
export var getNotificationTexts = createSelector([getColoredNotificationTexts, getCommonNotificationsTexts], function (coloredTariffsNotificationTexts, commonNotificationTexts) {
  return coloredTariffsNotificationTexts || commonNotificationTexts || emptyObj;
});
export var getNotificationAnchorId = function getNotificationAnchorId(state) {
  return getNotificationTexts(state).anchorId;
};
export var getNotificationButtonText = function getNotificationButtonText(state) {
  return getNotificationTexts(state).buttonText;
};
export var getColoredTariffsNotificationText = function getColoredTariffsNotificationText(state) {
  return getNotificationTexts(state).text;
};
export var getNotificationVariant = function getNotificationVariant(state) {
  return getNotificationTexts(state).variant || DEFAULT_NOTIFICATION_VARIANT;
};
export var getAddressNotificationText = createSelector([getColoredTariffsNotificationText, getFullAddress, selectFiasAddress], function (text, fullAddressOld, fiasAddress) {
  return text && (fiasAddress || fullAddressOld) && "".concat(text, " ").concat(fiasAddress || fullAddressOld);
});
export var getFilteredTabs = createSelector([getTariffTabs, getGroupedTariffsList], function (tabs, tariffs) {
  return tabs.filter(function (_ref2) {
    var _tariffs$key;
    var key = _ref2.key;
    return (((_tariffs$key = tariffs[key]) === null || _tariffs$key === void 0 ? void 0 : _tariffs$key.length) || 0) > 0;
  });
});
export var getTariffTabsList = createSelector([getFilteredTabs], function (tabs) {
  return tabs.map(function (_ref3) {
    var title = _ref3.content.title,
      key = _ref3.key;
    return {
      id: key,
      title: title
    };
  });
});

// селектор определяет по какому флоу будет осуществляться проверка адреса
// (с переходом сразу в конструктор либо с полной формой отправки заявки)
export var getIsRedirectToFTTBDetailsPage = function getIsRedirectToFTTBDetailsPage(state) {
  return getModalTariffData(state).isRedirectToFTTBDetailsPage;
};